import React from 'react';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="split">
        <div>
          <p className="eyebrow">About Us</p>
          <h2>India-based technology company delivering digital solutions.</h2>
        </div>

        <div>
          <p>
            Arthanova Global Private Limited is an India-based technology company delivering
            software development, AI, automation and digital product solutions for clients
            in India and overseas.
          </p>

          <p>
            We work directly with businesses to build practical platforms, improve
            operations and support long-term digital growth.
          </p>
        </div>
      </div>
    </section>
  );
}